import React, { useState } from "react";
import axios from 'axios';
import { setUserSession } from "./service/AuthService";
import { Row, Col } from "react-bootstrap";
import { Stack, TextField, Button, Modal, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Logo from "./dist/images/tc-logo-horizontal.png";
import "./styles/Login.css";
import { apiClient } from './service/ApiClient';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const LoginForm = (props) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [showResetModal, setShowResetModal] = useState(false);

  let history = useNavigate();

  const submitHandler = (event) => {
    event.preventDefault();
    if (username.trim() === '' || password.trim() === '') {
      setErrorMessage('Both username and password are required');
      return;
    }
    setErrorMessage(null);

    const requestBody = {
      action: "login",
      username: username,
      password: password
    };

    apiClient.post('login', requestBody)
      .then(async (response) => {
        const { user, token } = response.data;

        // store user and token
        setUserSession(user, token);

        // store login_ts for reference on logout
        const loginTsISO = new Date().toISOString();
        sessionStorage.setItem('login_ts', loginTsISO);

        // log session start (creates row in tc_user_credits_log)
        try {
          const resp = await apiClient.post(
            'manageusercredits',
            {
              action: 'logSessionStart',
              organization: user.organization.toLowerCase(),
              username: user.username,
              login_ts: loginTsISO,
              user_agent: navigator.userAgent
            },
            {
              headers: { Authorization: `Bearer ${token}` }
            }
          );
          console.log('Session start logged:', resp.data);
        } catch (e) {
          console.warn('logSessionStart failed:', e?.message || e);
        }

        // redirect after login
        history('/customer');
      })
      .catch(error => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          setErrorMessage(error.response.data.message);
        } else {
          setErrorMessage('Sorry... the backend server is down! Please try again later.');
        }
      });
  };

  const handleResetPassword = async () => {
    setResetMessage('');
    setErrorMessage('');

    if (!resetEmail.trim()) {
      setResetMessage('Email is required');
      return;
    }

    const requestBody = {
      action: "resetPwd",
      username: username,
      email: resetEmail
    };

    try {
      await apiClient.post('login', requestBody);
      setResetMessage('Reset link sent. Please check your email.');
    } catch (err) {
      const message = err?.response?.data?.message || 'Failed to send reset email. Try again later.';
      setErrorMessage(message);
    }
  };

  return (
    <Stack spacing={2}>
      <Row>
        <Col>
          <img src={Logo} style={{ width: "250px" }} className="center" alt="Logo" />
          <hr />
          <h5 className="text-info text-center">Portal Login</h5>
          <hr />
          <form onSubmit={submitHandler}>
            <Stack direction='column' spacing={2}>
              <TextField label='User Name' type='text' onChange={event => setUsername(event.target.value)} />
              <TextField label='Password' type='password' onChange={event => setPassword(event.target.value)} />
              <Button variant="contained" className="btn-teal" type="submit">Login</Button>
            </Stack>
          </form>
          <hr />
          {errorMessage && <p className="text-danger mb-0 h6">{errorMessage}</p>}
        </Col>
      </Row>

      <Row>
        <Col className="d-flex justify-content-center">
          <Link
            to="#"
            onClick={(e) => {
              e.preventDefault();
              setResetEmail('');
              setResetMessage('');
              setErrorMessage(null);
              setShowResetModal(true);
            }}
            style={{ textDecoration: 'underline', color: '#0d6efd', fontSize: '14px' }}
          >
            Forgot Password?
          </Link>
        </Col>
      </Row>

      <Row className="py-4">
        <Col className="text-center">
          <span>
            Are you new here?{' '}
            <Link
              to="/Register"
              style={{ textDecoration: 'underline', color: '#0d6efd', fontSize: '14px' }}
            >
              Register Now
            </Link>
          </span>
        </Col>
      </Row>

      <Modal open={showResetModal} onClose={() => setShowResetModal(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" align="center">Reset Password</Typography>
          <TextField
            fullWidth
            margin="normal"
            label="Enter your email"
            type="email"
            value={resetEmail}
            onChange={(e) => setResetEmail(e.target.value)}
          />
          {(resetMessage || errorMessage) && (
            <Typography color={resetMessage ? 'success' : 'error'}>
              {resetMessage || errorMessage}
            </Typography>
          )}

          <Stack direction="row" spacing={2} justifyContent="flex-end" mt={2}>
            <Button variant="contained" type="button" onClick={handleResetPassword}>Send Link</Button>
            <Button variant="outlined" onClick={() => setShowResetModal(false)}>Cancel</Button>
          </Stack>
        </Box>
      </Modal>
    </Stack>
  );
};

export default LoginForm;
